import request from "@/plugins/axios";

/**
 * AppInfo
 */
export function findAllAdminAppInfos() {
    return request.get("/appAdmin/appInfos")
}

export function findAllUserAppInfos() {
    return request.get("/user/appInfos")
}

export function createAppInfo(appName, desc) {
    let data = new URLSearchParams()
    data.append("appName", appName)
    data.append("desc", desc)
    return request.post("/appAdmin/appInfo", data)
}

export function modifyAppInfo(id,appName,desc) {
    let data = new URLSearchParams()
    data.append("appName", appName)
    data.append("appDescription", desc)
    return request.put(`/appAdmin/appInfo/${id}`, data)
}

export function deleteAppInfo(id) {
    return request.delete(`/appAdmin/appInfo/${id}`)
}

export function findAllAppAuthorityByAppId(appId) {
    let params = new URLSearchParams()
    params.append("appId",appId)
    return request.get('/appAdmin/appAuthorities/appId',{params})
}

export function createAppAuthority(appId,userId) {
    let data = new URLSearchParams()
    data.append("appId",appId)
    data.append("userId",userId)
    return request.post("/appAdmin/appAuthority",data)
}

export function deleteAppAuthority(appAuthorityId) {
    return request.delete(`/appAdmin/appAuthority/${appAuthorityId}`)
}
